import { useEffect, useRef, useState, useCallback } from "react";
import { Icon, Button, Container, Header, SpaceBetween, Spinner } from "@cloudscape-design/components"
import { useApi } from "../Api";
import { RegisterTouchToMouse, UnregisterTouchToMouse } from "../touchtomouse";
//import KeyboardToggleButton from "../KeyboardToggle";
import '../pretty.css';
import Joystick from'rc-joystick'
import CustomCursor from "../CustomCursor";



window.gameliftstreams.setLogLevel('debug'); // note: defaults to 'none'
function getExpiresInSeconds(expires_at){
  const curSec = Math.floor(Date.now()/1000);
  var ret= parseInt(expires_at?expires_at:curSec) - curSec;
  return ret;

}
/**
 * Detects if the current device is mobile based on user agent and touch capabilities.
 * @returns {boolean} True if device is mobile, false otherwise
 */
function checkIfMobile() {
  //return true; // force mobile for testing
  const ua = navigator.userAgent;

  const mobileRegex =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  const isMobileDevice = mobileRegex.test(ua);

  const isChromeMobile =
    ua.includes('Chrome') && (
      ('maxTouchPoints' in navigator && navigator.maxTouchPoints > 0) ||
      ('ontouchstart' in window) ||
      window.matchMedia('(hover: none)').matches ||
      window.matchMedia('(pointer: coarse)').matches
    );

  // iPadOS Safari in desktop mode: UA looks like macOS but device is touch-only
  const isIPadDesktopUA =
    /Macintosh/.test(ua) &&
    'maxTouchPoints' in navigator &&
    navigator.maxTouchPoints > 1;

  return isMobileDevice || isChromeMobile || isIPadDesktopUA;
}


let joystick = ''
var GameLiftStreams = null;

function PlaytestPlayer({onStop, Environment, FocusGroupGrantId}){
  const Api = useApi();
  const apiRef = useRef(Api);
  const videoRef = useRef(null);
  const audioRef = useRef(null);
  const containerRef = useRef(null);
  const streamSessionArnRef = useRef(null);
  const streamSessionGrantRef = useRef(null);
  const stoppingRef = useRef(false);
  const cleanupReasonRef = useRef("unmount");
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [location, setLocation] = useState(null);
  const [rotate, setRotate] = useState(false);
  const [mobileFs, setMobileFs] = useState(false);
  const [virtual, setVirtual] = useState(checkIfMobile());
  const [inputAttached, setInputAttached] = useState(false);
  const sessionKey = "session_"+Environment;

  useEffect(() => {
    apiRef.current = Api;
  }, [Api]);

  const reportStreamEvent = useCallback((event, state, streamSessionArn)=>{
    const arn = streamSessionArn || streamSessionArnRef.current;
    console.log(
      `Stream client event ` +
      `arn=${arn || 'unknown'} ` +
      `event=${event} ` +
      `state=${state || 'none'}`
    );
    apiRef.current.post('StreamClientEvent/', {
      StreamSessionArn: arn,
      Event: event,
      State: state
    }).catch(()=>{});
  },[])

  const disconnect = useCallback((reason)=>{
    if(stoppingRef.current) return;
    stoppingRef.current = true;
    cleanupReasonRef.current = reason || "disconnect";
    setLocation(null);
    onStop();
  },[onStop])

  const terminate = useCallback(async ()=>{
    if(stoppingRef.current) return;
    stoppingRef.current = true;

    const streamSessionArn = streamSessionArnRef.current;
    const streamSessionGrant = streamSessionGrantRef.current;

    cleanupReasonRef.current = "terminate";

    sessionStorage.removeItem(sessionKey);
    streamSessionGrantRef.current = null;

    reportStreamEvent("terminate", "user", streamSessionArn);

    try {
      if (streamSessionArn) {
        await apiRef.current.post('TerminateStreamSession/', { StreamSessionArn: streamSessionArn, StreamSessionGrant: streamSessionGrant });
        reportStreamEvent("terminate-request-succeeded", "none", streamSessionArn);
      }
    }
    catch (err) {
      console.error(err);
      reportStreamEvent("terminate-failed", err?.message || String(err), streamSessionArn);
    }

    try{
      GameLiftStreams?.close?.();
    }
    catch(err){
      console.log(err);
    }
    GameLiftStreams = null;
    setLocation(null);
    onStop();
  },[onStop, reportStreamEvent, sessionKey])

  useEffect(() => {
    if (!videoRef.current || !audioRef.current) return;
      GameLiftStreams = new window.gameliftstreams.GameLiftStreams({
      videoElement: videoRef.current,
      audioElement: audioRef.current,
      inputConfiguration: {
          autoMouse: true,
          autoKeyboard: true,
          autoGamepad: true,
          hapticFeedback: true,
          setCursor: 'visibility',
          autoPointerLock: true,
      },
      clientConnection: {
          connectionState: (state)=>{
            console.log(state);
            reportStreamEvent("connection-state", state);
            if (state === 'disconnected')disconnect("disconnected");
          },
          channelError: (error)=>{
            console.log(error);
            reportStreamEvent("channel-error", error?.message || String(error));
            disconnect("channel-error");
          },
          serverDisconnect: (reasoncode)=>{
            console.log(reasoncode);
            reportStreamEvent("server-disconnect", reasoncode ? String(reasoncode) : "none");
            disconnect("server-disconnect");
          },
          applicationMessage: (message)=>{console.log(message)},
      }
    });

    const SIGNAL_RESPONSE_DELAY_MS = 1000;
    const STARTUP_TIMEOUT_MS = 12 * 60 * 1000;
    const CONNECTED_TRANSITION_TIMEOUT_MS = 10 * 1000;

    const delay = (milliseconds) =>
      new Promise((resolve) => setTimeout(resolve, milliseconds));

    const hasTimedOut = (deadline) => Date.now() >= deadline;

    const reconnectSavedSession = async () => {
      var savedSessionJson = sessionStorage.getItem(sessionKey);
      if (!savedSessionJson) {
        return null;
      }

      var savedSession = null;
      try {
        savedSession = JSON.parse(savedSessionJson);
      }
      catch (err) {
        console.error(err);

        sessionStorage.removeItem(sessionKey);
        return null;
      }

      if (!savedSession?.StreamSessionArn || getExpiresInSeconds(savedSession.expires_at) <= 10) {
        sessionStorage.removeItem(sessionKey);
        streamSessionGrantRef.current = null;

        return null;
      }

      const reconnectArn = savedSession.StreamSessionArn;
      streamSessionArnRef.current = reconnectArn;
      streamSessionGrantRef.current = savedSession.StreamSessionGrant || null;

      reportStreamEvent("reconnect-candidate", "saved-session", reconnectArn);

      console.log("Reconnecting to session");

      const reconnectDeadline = Date.now() + STARTUP_TIMEOUT_MS;
      let connectedDeadline = null;

      let lastReconnectStatus = null;

      while (!stoppingRef.current && !hasTimedOut(reconnectDeadline)) {
        const response = await apiRef.current.post('GetSignalResponse/', {
          StreamSessionArn: reconnectArn,
          StreamSessionGrant: streamSessionGrantRef.current
        });

        if (stoppingRef.current) return null;

        setLocation(response.Location);

        const status = response.Status || "unknown";
        if (status !== lastReconnectStatus) {
          lastReconnectStatus = status;

          reportStreamEvent("reconnect-status", status, reconnectArn);
        }

        switch (status) {
          case 'CONNECTED':
            setLoading(true);

            if (connectedDeadline === null) {
              connectedDeadline = Date.now() + CONNECTED_TRANSITION_TIMEOUT_MS;
            }

            if (hasTimedOut(connectedDeadline)) {
              throw new Error('Existing stream session is still connected. Please retry in a few seconds.');
            }

            await delay(SIGNAL_RESPONSE_DELAY_MS);
            break;

          case 'ACTIVATING':
          case 'RECONNECTING':
            console.log('Waiting...');

            setLoading(true);

            await delay(SIGNAL_RESPONSE_DELAY_MS);
            break;

          case 'ACTIVE':
          case 'PENDING_CLIENT_RECONNECTION': {
            const reconnectSignalRequest = await GameLiftStreams?.generateSignalRequest();

            reportStreamEvent("signal-request-generated", "reconnect", reconnectArn);

            reportStreamEvent("reconnect-start", "create-connection", reconnectArn);

            let reconnectResult;
            try {
              reconnectResult = await apiRef.current.post('ReconnectStreamSession/', {
                SignalRequest: reconnectSignalRequest,
                StreamSessionArn: reconnectArn,
                StreamSessionGrant: streamSessionGrantRef.current
              });
            }
            catch (err) {
              reportStreamEvent("reconnect-failed", err?.message || String(err), reconnectArn);

              throw err;
            }

            const signalResponse = reconnectResult.SignalResponse;
            if (!signalResponse) {
              const err = new Error('Reconnect did not return a signal response.');

              reportStreamEvent("reconnect-failed", err.message, reconnectArn);

              throw err;
            }

            reportStreamEvent("reconnect-response", "signal-response", reconnectArn);
            reportStreamEvent("signal-response-received", "reconnect", reconnectArn);

            return signalResponse;
          }

          case 'ERROR':
          case 'TERMINATING':
          case 'TERMINATED':
            reportStreamEvent("reconnect-unavailable", status, reconnectArn);

            sessionStorage.removeItem(sessionKey);

            streamSessionArnRef.current = null;
            streamSessionGrantRef.current = null;

            return null;

          default:
            throw new Error('Unexpected stream session status while reconnecting: ' + status);
        }
      }

      if (stoppingRef.current) return null;

      throw new Error('Timed out waiting to reconnect to the existing stream session.');
    };

    const createNewSession = async () => {
      const signalRequest = await GameLiftStreams?.generateSignalRequest();

      reportStreamEvent("signal-request-generated", "new-session");

      // FocusGroupGrantId is set only by the Focus Group login spike.
      // The server redeems it and injects that player's Pragma session as
      // launch args. Undefined for the normal portal paths, which is a no-op.
      const createResult = await apiRef.current.post('CreateStreamSession/', { SignalRequest: signalRequest, Environment: Environment, FocusGroupGrantId: FocusGroupGrantId });

      // The user can leave/terminate while CreateStreamSession is in flight.
      // Best-effort cleanup if a session was created after the client stopped.
      // GameLift cannot terminate a session while it is still ACTIVATING;
      // normal placement/connection timeouts will clean it up in that case.
      if (stoppingRef.current) {
        if (createResult?.StreamSessionArn) {
          try {
            await apiRef.current.post('TerminateStreamSession/', {
              StreamSessionArn: createResult.StreamSessionArn,
              StreamSessionGrant: createResult.StreamSessionGrant || null
            });

            reportStreamEvent("terminate-request-succeeded", "stale-create", createResult.StreamSessionArn);
          }
          catch (err) {
            reportStreamEvent("terminate-failed", err?.message || String(err), createResult.StreamSessionArn);

            console.error(err);
          }
        }

        return null;
      }

      if (!createResult?.StreamSessionArn) {
        throw new Error('The server did not return a stream session.');
      }

      if (FocusGroupGrantId && !createResult.StreamSessionGrant) {
        throw new Error('The server did not return a stream-session control grant.');
      }

      streamSessionArnRef.current = createResult.StreamSessionArn;
      streamSessionGrantRef.current = createResult.StreamSessionGrant || null;

      sessionStorage.setItem(sessionKey,
        JSON.stringify({
          expires_at: (Date.now() / 1000) + (2 * 3600),
          StreamSessionArn: createResult.StreamSessionArn,
          StreamSessionGrant: createResult.StreamSessionGrant || null
        }));

      reportStreamEvent("create-stream-returned", "none", createResult.StreamSessionArn);

      let signalResponse = '';

      // Backstop only: a failed placement reports itself, and can take 10 minutes.
      const signalDeadline = Date.now() + STARTUP_TIMEOUT_MS;

      while (!stoppingRef.current && !signalResponse) {
        if (hasTimedOut(signalDeadline)) {
          throw new Error('Timed out starting the stream session. Please try again.');
        }

        console.log('Waiting...');

        setLoading(true)

        await delay(SIGNAL_RESPONSE_DELAY_MS);

        const response = await apiRef.current.post('GetSignalResponse/', {
          StreamSessionArn: createResult.StreamSessionArn,
          StreamSessionGrant: streamSessionGrantRef.current
        });

        //console.log(response);
        if (response.Status === 'ERROR' || response.Status === 'TERMINATED' || response.Status === 'TERMINATING') {
          sessionStorage.removeItem(sessionKey);

          streamSessionArnRef.current = null;
          streamSessionGrantRef.current = null;

          // Terminal status (e.g. ERROR from a placement timeout): surface it instead of hanging on "Waiting...".
          throw new Error('Stream session failed to start (' + response.Status + (response.StatusReason ? ': ' + response.StatusReason : '') + '). Please try again.');
        }

        signalResponse = response.SignalResponse;

        setLocation(response.Location);
      }

      if (stoppingRef.current) return null;

      reportStreamEvent("signal-response-received", "new-session", createResult.StreamSessionArn);

      return signalResponse;
    };


    const init = async () => {
      try {
        try {
          await GameLiftStreams?.enableMicrophone();
        }
        catch (error) {
          console.error(error);
        }

        if (stoppingRef.current) return;

        let signalResponse = await reconnectSavedSession();

        if (stoppingRef.current) return;

        if (!signalResponse) {
          signalResponse = await createNewSession();
        }

        if(stoppingRef.current) return;

        reportStreamEvent("process-signal-response-start");

        await GameLiftStreams?.processSignalResponse(signalResponse);

        reportStreamEvent("process-signal-response-complete");

        GameLiftStreams?.attachInput();

        setInputAttached(true);

        reportStreamEvent("input-attached");
      }
      catch(err)
      {
        if(!stoppingRef.current){
          reportStreamEvent("client-error", err?.message || String(err));
          setError(err.message)
        }
        console.log(err)
      }
      finally
      {
        if(!stoppingRef.current) setLoading(false)
      }
    }

    const handlePageShow = (event) => {
      if (event.persisted) {
        window.location.reload();
      }
    };

    const handlePageHide = ()=>{
      if(stoppingRef.current) return;
      stoppingRef.current = true;
      cleanupReasonRef.current = "pagehide";
      reportStreamEvent("pagehide", "browser-page-hidden");
    };

    window.addEventListener('pageshow', handlePageShow);
    window.addEventListener('pagehide', handlePageHide);
    
    init();

    const touchRef = videoRef.current

    RegisterTouchToMouse(touchRef);

    return () => {
      stoppingRef.current = true;

      window.removeEventListener('pageshow', handlePageShow);
      window.removeEventListener('pagehide', handlePageHide);

      reportStreamEvent("client-cleanup", cleanupReasonRef.current);

      GameLiftStreams?.close?.();
      GameLiftStreams = null;

      UnregisterTouchToMouse(touchRef);
    }
    // eslint-disable-next-line
  }, []);


  useEffect(()=>{
    if ('keyboard' in navigator && 'lock' in navigator.keyboard) {
      const handle = () => {
          if (window.document.fullscreenElement) {
              navigator.keyboard.lock([
                  // Specify only required keys
                  "Escape"
              ]);
          }
        }
      window.document.addEventListener('fullscreenchange', handle);
      return () => {
        window.removeEventListener('fullscreenchange', handle);
      };
    }

  },[])

  useEffect(()=>{
    if (checkIfMobile()) {
      setRotate(window.matchMedia("(orientation: portrait)").matches);
      const handle = () => {
          setMobileFs(false);
          setRotate(window.matchMedia("(orientation: portrait)").matches);
        }
        window.addEventListener('orientationchange', handle);
        window.addEventListener('resize', handle);
      return () => {
        window.removeEventListener('orientationchange', handle);
        window.removeEventListener('resize', handle);
      };
    }

  },[])
/*
  useEffect(() => {
    const handleGlobalKey = (e) => {
      console.log('Global keydown:', e.key, e);  // Should see 'e'
    };
    document.addEventListener('keydown', handleGlobalKey);
    return () => document.removeEventListener('keydown', handleGlobalKey);
  }, []);
*/

  const handleFullscreen = () => {
    if (containerRef.current) {
      if(checkIfMobile()){
        //toggling so bakwards?
        if(mobileFs)
          containerRef.current.focus();
        else
          containerRef.current.blur();
        setMobileFs(!mobileFs);
      }else if (containerRef.current.requestFullscreen) {
        containerRef.current.requestFullscreen();
      } else if (containerRef.current.webkitRequestFullscreen) { // Safari
        containerRef.current.webkitRequestFullscreen();
      } else if (containerRef.current.msRequestFullscreen) { // IE11
        containerRef.current.msRequestFullscreen();
      }
      // lets just tru t

      containerRef.current.focus();
    }
  };

  const preventDefault = (e) => e.preventDefault();

  return(
    <>
      <SpaceBetween  direction="horizontal" size="m" alignItems="center">
        {/*<KeyboardToggleButton/> */}
        {error?<>Error: {error}<br/></>:
          <>
            {loading?<Spinner/>:<>
            <Button onClick={handleFullscreen} >Fullscreen</Button>
            {checkIfMobile()?<Button onClick={()=>{setVirtual(!virtual)}} >Virtual Controls</Button>:null}
            </>}
          </>
        }
        <Button onClick={terminate} >Terminate</Button>
        {inputAttached? 
        <Button onClick={()=>{GameLiftStreams?.detachInput();setInputAttached(false);}} ><Icon name="keyboard" />&nbsp;&nbsp;Detatch Input</Button>:
        <Button onClick={()=>{GameLiftStreams?.attachInput();setInputAttached(true);}} ><Icon name="keyboard" />&nbsp;&nbsp;Attach Input</Button>}
        {location?location:null}
        {rotate?<>Rotate to landscape for best experience.</>:null}
      </SpaceBetween>
      <br/>
      {rotate&&false?
      <div style={{ background: '#333', padding: '40px' }}>
        <div className="rotate-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="white"
              width="100"
              height="100"
            >
              <path d="M0 0h24v24H0z" fill="none"/>
              <path d="M16.48 2.52c3.27 1.55 5.61 4.72 5.97 8.48h1.5C23.44 4.84 18.29 0 12 0l-.66.03 3.81 3.81 1.33-1.32zm-6.25-.77c-.59-.59-1.54-.59-2.12 0L1.75 8.11c-.59.59-.59 1.54 0 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12L10.23 1.75zm4.6 19.44L2.81 9.17l6.36-6.36 12.02 12.02-6.36 6.36z"/>
            </svg>
        </div>  
      </div>:null}
      <div ref={containerRef}
          className={mobileFs?"streamFullscreenContainerMobile":""}
          style={{
            width: '100%',
            height: '100%',
            //backgroundColor: 'green', // or any color you want
            margin: 0,
            padding: 0,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        }} 
      >
        <CustomCursor>
          <video ref={videoRef} autoPlay playsInline disablePictureInPicture  microphone    
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain', // or 'contain'
              display: 'block',
            }}
          />
        </CustomCursor>
        <audio ref={audioRef} autoPlay/>
        {virtual?
        <div style={{position:'absolute', right:'16px', bottom:'16px' }} >
          <Button onClick={()=>{    
              videoRef.current.dispatchEvent(new KeyboardEvent('keydown', {
                  key: 'e', code: 'KeyE', bubbles: true 
              }));
              
              // Send E up (required)
              setTimeout(() => videoRef.current.dispatchEvent(new KeyboardEvent('keyup', {
                  key: 'e', code: 'KeyE', bubbles: true 
              })), 50);
              
            }} >E</Button> 
          <Button onClick={()=>{    
              videoRef.current.dispatchEvent(new KeyboardEvent('keydown', {
                  key: 'Tab', code: 'Tab', bubbles: true 
              }));
              
              // Send E up (required)
              setTimeout(() => videoRef.current.dispatchEvent(new KeyboardEvent('keyup', {
                  key: 'Tab', code: 'Tab', bubbles: true 
              })), 50);
              
            }} >Tab</Button> 
          <div style={{touchAction: 'none'  }} 
              onTouchStart={preventDefault}
              onTouchMove={preventDefault}
              onTouchEnd={preventDefault}
          >
            <Joystick
              baseRadius={80}
              controllerRadius={32}
              autoReset
              throttle={16}
              onChange={({ angle, direction, distance }) => {
                // angle: 0-360, distance: 0-1, direction: 'Top' | 'Bottom' | ...
                        // Only trigger if the joystick is moved significantly
              // if (distance < 20) return;

                if(joystick !== direction){
                  //console.log(angle, distance, direction)
                  
            
                  // Define which keys to simulate based on direction
                  const keyMapping = {
                    Top:   { key: 'w', code: 'KeyW' },
                    Bottom:{ key: 's', code: 'KeyS' },
                    Left:  { key: 'a', code: 'KeyA' },
                    Right: { key: 'd', code: 'KeyD' }
                  };
                  
                  const oldKey = keyMapping[joystick];
                  if(oldKey){
                    //console.log('old', oldKey)
                    const keyUpEvent = new KeyboardEvent('keyup', {
                      key: oldKey.key,      // 'w'
                      code: oldKey.code,    // 'KeyW'
                      bubbles: true,
                      cancelable: true
                    });
                    videoRef.current.dispatchEvent(keyUpEvent);
                  }
              
                  const keyCode = keyMapping[direction];
                  if (keyCode) {
                    //console.log('key', keyCode)
                    const keyDownEvent = new KeyboardEvent('keydown', {
                      key: keyCode.key,     // 'w'
                      code: keyCode.code,   // 'KeyW'
                      bubbles: true,
                      cancelable: true
                    }); 
                      videoRef.current.dispatchEvent(keyDownEvent);
                  }
                  
                  joystick = direction
                }

              }}
            />
            </div>
        </div>
        :null}
      </div>
    </>

  )
}


// Exported so the Focus Group login spike can reuse the whole stream
// player -- signalling, reconnect, input handling -- instead of duplicating it.
// autoStart skips the Play button, because the spike has already had the user
// click through a login.
export function Playtest({Environment, FocusGroupGrantId, autoStart}){
  const [run, setRun] = useState(!!autoStart)

  return(
    <Container
    header={<Header variant="h2">{Environment}</Header>}
>
    {run?
      <PlaytestPlayer onStop={()=>setRun(false)} Environment={Environment} FocusGroupGrantId={FocusGroupGrantId} />
      :<Button onClick={()=>setRun(true)}>Play</Button>}
    </Container>
  )
}
export function PlaytestPlaytest(){
  return (<Playtest Environment={"Playtest"} />)
}
export function PlaytestDevelopment(){
  return (<Playtest Environment={"Tomahawk"} />)
}

export function PlaytestDemo(){
  return (<Playtest Environment={"Demo"} />)
}
